switch (true) {
	case navigator.userAgent.indexOf('Chrome') > -1 :
		document.querySelector('html').classList.add('chrome');

	case navigator.userAgent.indexOf('MSIE') > -1 :
		document.querySelector('html').classList.add('ie');

	case navigator.userAgent.indexOf('Firefox') > -1 :
		document.querySelector('html').classList.add('firefox');
		break;

	case navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf('Chrome') == -1 :
	case navigator.userAgent.indexOf("iPhone") > -1 :
		document.querySelector('html').classList.add('safari');
		break;

	case navigator.userAgent.toLowerCase().indexOf("op") > -1 && navigator.userAgent.indexOf('Chrome') == -1 :
		document.querySelector('html').classList.add('opera');
		break;
}

/* Functions all around */
	function logoStatus () {
		const logo = $('header .logo');

		switch (true) {
			case (logo.parent('header') && logo.parent().hasClass('active')):
			case ($(document).scrollTop() > 10):
				logo.addClass('closed');
				return false;
		}
		logo.removeClass('closed');
	}

	function parallaxer () {
		const pH = this.getBoundingClientRect().height;
		const pY = this.getBoundingClientRect().top;

		let perc = (pY + pH) / (window.innerHeight + pH) * 100;

		perc = perc <= 0 ? 0 : perc >= 100 ? 100 : perc;

		// below, "this.qS('img')" will get the first image only, meaning
		// you must put the image as firstest element possible contained in [parallaxer]
		this.querySelector('img').style.objectPosition =  'center ' + perc + '%';
	}

	function dragBar (el, e) {
		const bar = el;
		const i = el.firstElementChild;
		const bBound = bar.getBoundingClientRect();
		const w = bBound.width;

		const eX = e.clientX;

		const min = bBound.left + (w / bar.getAttribute('max'));
		const max = bBound.left + w;

		if (eX <= bBound.left) {
			i.style.left = '0';
			return false;
		}
		if (eX >= max) {
			i.style.left = '100%';
			return false;
		}

		const calc = ((eX - bBound.left) / w) * 100 ;

		i.style.left = calc + '%';
	}
	function dragMagnet (el, index) {
		const bar = el;
		const i = el.firstElementChild;
		const bBound = bar.getBoundingClientRect();
		const w = bBound.width;

		const arr = [0];

		let len = 0;
		while (len < 100) {
			// -1 because it starts with 0 and ends with 100
			len = len + (100 / (bar.getAttribute('max') - 1));
			arr.push(len);
		}

		const iPos = i.style.left;

		const min = bBound.left + (w / bar.getAttribute('max'));
		const max = bBound.left + w;

		let closest = arr.reduce(function (prev, curr) {
			if (i.style.left == '0') return 0; // 0 Percent
			if (i.style.left == '100%') return 100; // 100 Percent

			const iInt = parseInt(iPos.match(/[0-9]+/));
			return (Math.abs(curr - iInt) < Math.abs(prev - iInt) ? curr : prev);
		});

		i.style.transition = '.2s';
		i.style.left = (index !== undefined ? 100 / (bar.getAttribute('max') - 1) * index : closest) + '%';
		setTimeout(function () { i.style.transition = '' }, 200);

		return arr.indexOf(closest);
	}

	function scrollAt (to, offset, cb) {
		if (typeof offset == 'function') cb = [offset, offset = cb][0];
		offset = offset || 0;

		switch (true) {
			case (to instanceof Object): // Careful, "typeof" on an object doesn't work, causes a Maximum stack exceeded error
				to = $(to).offset().top; break;
				break;
			case (typeof to == 'number'):
				break;
			case (typeof to == 'string'):
				try { to = parseInt(to) }
				catch (e) { to = $(to).offset().top }
				break;

			default:
				return false;
		}

		const timing = 500 + Math.abs($('html, body').scrollTop() - to) / $('html, body').height() * 2000;

		$('html,body').animate(
			{ scrollTop: to - offset },
			timing
		);

		if (cb) setTimeout(cb, timing);
	}

	function scrollToNote (el) {
		if (!el) return false;
		if (el.hash) el = document.querySelector(el.hash);
		if (!el) return false;

		$(el).addClass('trigger');
		$(el).one('animationend', () => $(el).removeClass('trigger'));

		scrollAt(el, 200);
	}


/* Start executing (not people please) */
$(document).ready(() => {
	// logoStatus checks if logo should be opened or not
		setTimeout(() => logoStatus(),250);
		$(window).scroll(logoStatus);

	// Opening/closing menu
		$('header button').click(function (e) {
			e.preventDefault();

			$(this).parents('header').toggleClass('active');
			logoStatus(); // See above
		});

	// Open a link if clicked on parent whole block (in projects)
		$('.slider-projects .project').click(function () {
			window.open($(this).find('a.cta').attr('href'), '_self');
		});

	// Parallaxer management
		$(window).scroll(function () {
			$('[parallaxer]').each(parallaxer);
		});
		let parallaxerTimeout;
		$(window).resize(function () {
			clearTimeout(parallaxerTimeout);
			parallaxerTimeout = setTimeout(function () {
				$('[parallaxer]').each(parallaxer);
			},150);
		});

	// Form input class add/remove (filled style)
		// Tuto of the bastard:
			// DOM structure should be the input FOLLOWED BY a span (with the placeholder inside)
			// And this input + span should be in a label, which serves as a display:block
			// Then, instead of styling input:focus, you can use the "filled" class on the label
		$('form input').each(function () {
			// Prevent this function to execute by adding "nofill" class to inputs
			if ($(this).hasClass('nofill')) return false;

			switch (this.type) {
				case 'checkbox':
				case 'radio':
					// Do stuff
					break;

				case 'text':
				case 'email':
				case 'number':
				case 'phone':
				// etc if I forgot
					$(this).focus(() => $(this).parents('label').addClass('filled') );
					$(this).blur(() => {
						if ($(this).val().length == 0) $(this).parents('label').removeClass('filled');
					});
			}
		});

		$('.drag-bar').on('mousedown', function (e) {
			const el = this;
			const elName = el.getAttribute('data-slider');
			dragBar(this, e);
			document.body.style.userSelect = 'none';

			$('body').on('mousemove', function (e) { dragBar(el, e)});

			$('body').on('mouseup', () => {
				document.body.style.userSelect = '';
				$('body').off();

				const slider = $('[data-slider="' + elName + '"].slider')[0];

				const index = dragMagnet(el);

				newSlide(this, index);
			});
		});

		$('.indexes a').click(function (e) {
			e.preventDefault();

			const elName = $(this).parents('[data-slider]').data('slider');
			const slider = $('[data-slider="' + elName + '"].slider')[0];
			const index = $(this).parent().index();

			newSlide(this, index, true);

			if (window.matchMedia('(hover: none)').matches) scrollAt(slider, 100);
		});

		function newSlide (slider, ind, drag = false) {
			if (!$(slider).hasClass('slider-container')) {
				slider = $(slider).parents('.slider-container');

				if (!$(slider).hasClass('slider-container')) return false;
			}

			$(slider).find('li.active').removeClass('active');
			$(slider).find('li:nth-child(' + (ind+1) + ')').addClass('active');

			if (drag) dragMagnet($(slider).find('.drag-bar')[0], ind);
		}

		/*$('.drag-bar').on('touchstart', function (e) {
			e.preventDefault();
			const el = this;
			const elName = el.getAttribute('data-slider');
			dragBar(this, e);
			document.body.style.userSelect = 'none';

			$('body').on('touchmove', function (e) {
				e.preventDefault();
				console.log(e)
				dragBar(el, e);
			}, false);

			$('body').on('touchend', function () {
				document.body.style.userSelect = '';
				$('body').off();

				const slider = $('[data-slider="' + elName + '"].slider')[0];

				$(slider).find('li.active').removeClass('active');

				const index = dragMagnet(el);

				$($(slider).find('li').get(index)).addClass('active');
			}, false);
		}, false);*/
});

$(document).ready(function(){
	// Visual-cta changes
	/*$('.visual-cta span').each(function () { // Cancelled
		$(this).html(() => {
			const text = this.textContent;
			let str = '';

			for (let i = 0; i < text.length; i++) {
				str += '<i>' + text[i] + '</i>';
			}

			return str;
		});
	});*/


	// Scroll animation with automatic delay according to distance (yeah boy), and data-scroll-offset on elements to fix distance from viewport top
	$('a[href^="#"]').click(function (prim) {
		prim.preventDefault();

		if ($(this).hasClass('prevent-scroll')) return false;

		if ($(this).hasClass('note')) {
			scrollToNote(this);
			return false;
		}

		const el = $(this.hash)[0] || $(this).parents('section').next()[0];

		scrollAt(el, $(el).data('scroll-offset'));
	});

	setTimeout(function(){
		$('.cookie-box').addClass('cookie-appear');
	  }, 6000);

	$("#cookie-valide").click(function(e) {
		e.preventDefault();
		$('.cookie-content').addClass('display-none');
	});

	// Social-parent (button that opens) transition preventing first touch to redirect
	/*$('.social-parent').on('touchend', function (e) {
		if (!$(this).hasClass('opened')) e.preventDefault();

		$(this).toggleClass('opened');
	});

	if ($('body').hasClass('page--blog')) {
		$('main').on('touchend', function (ev) {
			if (ev.target != $('ul.socials')) console.log(ev);
		});
	}*/


	/*if ($('body').hasClass('page--blog')) {
		$('main').on('touchend', function (e) {
			if ($(ev.target).parents('.cta').length) {
				$(ev.target).parents('.cta').
				e.preventDefault();
			}
		});
	}*/
});



// Homepage texts
	$(document).ready(() => {
		$('.page--homepage .banner .intro').addClass('active');

		/* Automatic text changer on homepage banner */
		(() => {
			if (!$('body').hasClass('page--homepage')) return false;

			const span = $('.page--homepage .banner .blind-text:last')[0];

			if (!span) {
				return
			}
			const texts = ['Boost', 'Collect', 'Automate'];

			let textIncrement = 0;
			let timing = $(span).css('animation-duration').match(/[0-9,.]+/)[0] * 1000;

			$(span).on('animationstart animationiteration', () => {
				textIncrement--;
				if (textIncrement == -1) textIncrement = texts.length - 1;
				// Quick hack, quack quack (kill me): The element (span) has an after.
				// The span, AND the after, both have an animation each.
				// Which means that since the after is part of the span, the event occurs TWICE.
				// Fortunately, there are only 3 words so we move backwards (- 2), and it goes forwards (+ 1). Noice.

				setTimeout(() => { $(span).text(texts[textIncrement]) }, 500);
			});
		})();
	});


// "About" page slides
	$(document).ready(() => {
		let animating = false;
		function showTab (element) {
			const ind = $(element).index();
			setTimeout(function () {
				$(element)
					.show()
					.addClass('active');

				$($(element)
					.parents('.container')
					.find('.pagination li')
					.get(ind)
				).addClass('active');

				animating = false;
			}, ($(element).siblings().hasClass('active') ? 1100 : 0));
		}
		function hideTab (element) {
			$(element).removeClass('active');
			$(element)
				.parents('.container')
				.find('.pagination li.active')
				.removeClass('active');

			setTimeout(function () {
				$(element).hide();
				animating = false;
			}, 1100); // Careful, added 100 for a supershort pause (transition is 1000)
		}
		$('.tabs').each(function () {
			const el = this;

			$(el).find('li').hide();

			new Waypoint({
				element: el,
				handler: function () {
					$(el).removeClass('waypoint');
					showTab($(el).find('li').first()[0]);
					showTab($(el).siblings('.pagination').find('li').first()[0]);
					this.destroy();
				},
				offset: '50%'
			});

			$(el).parent().find('.next-tab').click(function (e) {
				e.preventDefault();

				if (animating) return false;

				animating = true;

				const t = $(el).find('li.active')[0];
				showTab($(t).next()[0] || $(t).siblings().first()[0]);
				hideTab(t);
			});

			$(el).parent().find('.pagination a').click(function (e) {
				e.preventDefault();

				if (animating) return false;

				animating = true;

				if ($(this).parents('li').hasClass('active')) return false;

				const ind = $(this).parents('li').index();

				showTab($(el).find('li').get(ind));
				hideTab($(el).find('li.active')[0]);
			});
		});
	});

// Works page, fadeIn opacity on scroll
	$(document).ready(() => {
		if (!$('body').hasClass('page--client')) return false;

		$('section.banner').each(function () {
			const s = this;
			let bg = window.getComputedStyle(s)['background-color'];
			let op = bg.match(/[0-9.]+\)$/)[0].slice(0, -1);
			bg = bg.slice(0, bg.match(/[0-9.]+\)$/).index);

			window.addEventListener('scroll', function (e) {
				s.style.backgroundColor = bg + (op - (window.scrollY / (window.innerHeight / 2) * op)) + ')'
			});
		});
	});




	// When user scroll ends, magnet-attach to closest section (on homepage only, not mobile)
	/*$(document).ready(() => {    ////////// I CAN'T CODE HELP ME
		if (document.body.classList.contains('page--homepage') && window.innerWidth < 768) return false;

		let scrollTimeout;
		let animating = false;

		function scroller () {
			if (animating) return false;
			animating = true;

			$(window).off('scroll');

			const top = $('html, body').scrollTop(); // Dat jQuery that was needed because of my flayme
			const ss = [];
			let closestIndex = 0;
			let bottomMost = 0;

			ss.push(document.querySelector('html'));
			ss.push(...Array.prototype.slice.call(document.querySelectorAll('section:not(.slider-projects)')));
			ss.push(...Array.prototype.slice.call(document.querySelectorAll('.slider-projects > .project'))); // wudchu look at that

			console.log(ss);

			for (let i in ss) {
				bottomMost = Math.max(bottomMost, top + ss[i].getBoundingClientRect().top);

				if (Math.abs(ss[i].getBoundingClientRect().top) < Math.abs(ss[closestIndex].getBoundingClientRect().top)) {
					closestIndex = i;
				}
			}

			if ($('html, body').scrollTop() > bottomMost) {
				animating = false;
				return false;
			}

			$('html, body').animate( // Find the other scroll Animate
				{ scrollTop: ss[closestIndex].getBoundingClientRect().top }, // Action
				1000,
				//Math.abs($('html, body').scrollTop() - $(ss[closestIndex]).offset().top) / $('html, body').height() * 12000, // Timing
				function () { // Complete
					setTimeout(function () {
						animating = false;
						console.log('scroll ends');

						$(window).on('scroll', scrollListener);
					}, 1000);
				}
			);

			console.log(ss[closestIndex], ss[closestIndex].getBoundingClientRect().top);

			animating = false;
		}

		// $(window).on('scroll', _.debounce(scroller, 500));


		$(window).on('scroll', scrollListener);

		function scrollListener () {
			clearTimeout(scrollTimeout);

			scrollTimeout = setTimeout(function () {
				scroller();
				console.log('timeout happened');
			}, 500);
		}
	});*/



// Article Sharer
	(() => { // Page Blog
		if (!$('body').hasClass('page--blog') && !$('body').hasClass('page--article')) return false;

		const defaultLinks = {
			fb: 'https://www.facebook.com/sharer/sharer.php?u=',
			tw: 'https://twitter.com/home?status=',
			li: 'https://www.linkedin.com/shareArticle?mini=true&url=',
			email: 'mailto:?body=Hey!%0AYou%20need%20to%20read%20this%20article%2C%20it\'s%20pretty%20cool!%0A%0A'
		}

		if ($('body').hasClass('page--blog')) {
			const sharers = $('.socials.sharer');

			sharers.each(function () {
				const parent = $(this).parents('li');
				const parentLink = $(this).parents('li').find('a')[0].href;

				$(this).find('li').each(function () {
					const shareName = $(this).attr('class');

					$(this).find('a').attr('href', defaultLinks[shareName] + parentLink);
				});
			});
		} else {
			$('.socials.sharer').each(function () {
				const parentLink = location.href;

				$(this).find('li').each(function () {
					const shareName = $(this).attr('class');

					$(this).find('a').attr('href', defaultLinks[shareName] + parentLink);
				});
			});
		}
	})();


// Automatic scrolling (autoscroll attribute to body)
	$(document).ready(function () {
		if ($('body').is('[autoscroll]')) {
			const elToGoTo = $($('body').attr('autoscroll'));

			if (elToGoTo.length) setTimeout(() => scrollAt(elToGoTo, 75), 1500);
		}
	});


// Be in the know and modal
	$(document).ready(function(){
		$('#bitk-modal').each((i, m) => { // Events on the modal (opening, closing, etc), no form submission
			m = $(m);

			let automaticModalOpenerTimeout;

			if (localStorage.modalValidated !== '1') setTimeout(() => m.removeClass('hidden'), 150);

			if (localStorage.modalValidated !== '1') { // Open modal after 20 seconds, every 5 times a blog article is opened
				localStorage.modalShownCount = parseInt(localStorage.modalShownCount) + 1 || 0;
				if (localStorage.modalShownCount == '5') localStorage.modalShownCount = 0;

				if (localStorage.modalShownCount == '0') {
					automaticModalOpenerTimeout = setTimeout(() => {
						if (!m.hasClass('hidden')) m.find('.opener').click();
					}, 20000);
				}
			}

			m.find('.opener').on('click', (e) => {
				e.preventDefault();
				m.toggleClass('opened');

				clearTimeout(automaticModalOpenerTimeout);
			});

			m.find('.never-ask').on('click', (e) => {
				e.preventDefault();

				m.addClass('hidden');
				setTimeout(() => m.removeClass('opened'), 250);

				localStorage.modalValidated = '1';
			});

			m.find('.closer').on('click', (e) => {
				e.preventDefault();

				m.removeClass('opened');
			});

			$('#bitk-bg').on('click', (e) => {
				e.preventDefault();

				m.removeClass('opened');
			});

			$(document).on('scroll', function (e) {
				if (localStorage.modalValidated == '1') return;

				const st = $(window).scrollTop();
				const bitk = $('section.beintheknow').offset().top;
				const win = $(window).height();

				if (m.hasClass('hidden') && st < bitk - (win / 3)) {
					m.removeClass('hidden');
				} else if (!m.hasClass('hidden') && st >= bitk - (win / 3)) {
					m.addClass('hidden');
					m.removeClass('opened');
				}
			});

			$(document).on('keyup', (e) => {
				if (e.key == 'Escape') $('#bitk-bg').click();
			});
		});


		$('.bitk-form').on('submit', function (e) { // Function for both modal and section, when submitting the form
			e.preventDefault();

			if (this.id == "bookingfree" || this.id == "bookingseat") {
				let error = $(this).find('label[data-error="true"]')
				if (error.length) {
					return false
				}
			}

			// First Action settings
				if ($(this).hasClass('submitting, submitted')) return false;
				$(this).addClass('submitting');

			// Event settings
				var action = $(this).attr('action');
				var tracker = {
					eventCategory: 'newsletter',
					eventAction: 'submit',
					eventLabel: location.pathname
				};

				// Send form and if success, callback to "endFormValidation()"
				if (navigator.sendBeacon) {
					tracker.transport = 'beacon';

					var formdata = new FormData($(this).get(0));
					var status = navigator.sendBeacon(action, formdata);

					if (status) endFormValidation(this);
				} else {
					$.post(action, 
						$(this).serialize(),
						(result) => {
							if (result.success) endFormValidation(this);
						},
						'json');
				}

				function endFormValidation (form) {
					// front js
						const parent = $(form).parents('.container').parent();
						parent.addClass('submitted').removeClass('submitting');
						parent.find('h2, h3').removeClass('active');
						parent.find('p, .form-container').slideUp(750);

						setTimeout(() => {
							parent.find('h2, h3').find('span').text('thank you');
							
							if (form.id == "beintheknow" || form.id == "beintheknow-modal") {
								parent.find('.subtitle').text('You have been subscribed.').slideDown(1000);
							} else {
								parent.find('.subtitle').text('Please check your mailbox.').slideDown(1000);
							}

							parent.find("h2, h3").addClass("active");

							let height = 100 + $("#form-seat .container").outerHeight(true);
              				$("#form-seat").css("height", `${height}px`);

							setTimeout(() => {
								$('#bitk-modal').addClass('hidden');
								if (parent.is($('#bitk-modal'))) {
									setTimeout(() => parent.removeClass('opened'), 500);
								} else {
									if (form.id == "beintheknow" || form.id == "beintheknow-modal") {
										$('.beintheknow').slideUp(1000);
                  					} else if (form.id == "bookingfree") {
										$("#form-free").toggleClass("open");
										$("#bookingfree").get(0).reset();
										$("#form-free .form-container form").removeClass("submitting");
										$("#form-free .form-container form label").removeClass("filled");
										$("#form-free").removeClass('submitted');
										$("#form-free h2 .blind-text").text("Book a free consultation");
										$("#form-free .form-container").css("display", "");
									} else if (form.id == "bookingseat") {
										$("#form-seat").toggleClass("open");
										$("#training-bi-calendar").addClass("hidden");
										$("#bookingseat").get(0).reset();
										$("#form-seat .form-container form").removeClass("submitting");
										$("#form-seat .form-container form label").removeClass("filled");
										$("#form-seat").removeClass("submitted");
										$("#form-seat").css("height", `0px`);
										$("#form-seat h2 .blind-text").text("Book your seat");
										$("#form-seat .subtitle").text("");
										$("#form-seat .form-container").css("display", "");
										setTimeout(() => $("#training-bi-calendar").removeClass("hidden"), 500);
										setTimeout(() => $("#bookingseat").addClass("hidden"), 500);
									}
								}
							}, 4000);
						}, 1000);


					// gtag
						if (typeof gtag == 'function') {
							gtag('event', tracker.eventAction, {
								'event_category': tracker.eventCategory,
								'event_label': tracker.eventLabel
							});

							gtag('config', 'UA-35785529-1', {
								'page_path': (location.pathname + '/beintheknown').replace(/([^:]\/)\/+/g, "$1")
							});
						}

					// linkedin
						document.body.insertAdjacentHTML('beforeend',
							'<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=1817834&conversionId=1919450&fmt=gif" />');

					localStorage.modalValidated = '1';
				}

			return false;
		});
	});